import { Oval } from 'react-loader-spinner'
import style from './popupContent.module.css';
import cn from 'classnames';
const PopupContent = ({ type, heading, message, buttons }) => {
    if (type === 'spinner') {
        return (
            <div className='w-100'>
                <div className='d-flex flex-column justify-content-center p-3'>
                    <div className='pb-4'>
                        <span className={cn('fw-500 fs_24', style.headingColor)}>{heading}</span>
                    </div>
                    <div className='d-flex align-items-center'>
                        <div className='mr-3 d-flex justify-content-center align-items-center'>
                            <Oval
                                visible={true}
                                height="30"
                                width="30"
                                color="var(--primary-icon-color)"
                                secondaryColor="var(--secondary-btn-border)"
                                ariaLabel="oval-loading"
                                strokeWidthSecondary=""
                                wrapperStyle={{}}
                                wrapperClass=""
                            />
                        </div>
                        <div>
                            <span className={cn('fs_16 fw-400', style.headingColor)}>{message}</span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    if (type === 'popup') {
        let eMsg = 'request failed';
        let sMsg = '', errorConfMsg = '';
        if (typeof message === 'object' || message instanceof Object) {
            const { errorMessage, supportMessage, message: errMsg, errorConfirmationMsg } = message;
            eMsg = errMsg || errorMessage || 'request failed';
            sMsg = supportMessage;
            errorConfMsg = errorConfirmationMsg;
        } else if (typeof message === 'string') {
            eMsg = message;
        }
        return (
            <div className='w-100'>
                <div className='d-flex flex-column justify-content-center p-3'>
                    <div className='pb-4'>
                        <span className={cn('fw-500 fs_24', style.headingColor)}>{heading}</span>
                    </div>

                    <div className='d-flex align-items-center'>
                        {!!errorConfMsg ?
                            <div className={style.message}>
                                <span>{errorConfMsg}</span>
                            </div>
                            : null
                        }
                        <div className={style.message}>
                            <span>{eMsg || sMsg}</span>
                        </div>
                    </div>

                    <div className={cn('pt-4', style.buttonsContainer)}>
                        {buttons.map((button, index) => (
                            <button
                                key={`popup-button-${button.text}`}
                                className={cn('col px-0 ', button.btnType === 'cancel'? style.cancelBtn: style.submitBtn)}
                                onClick={button.onClick}
                            >
                                <span>{button.text}</span>
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        );
    }

}

export default PopupContent